/**
 * Converts a boolean value to its string representation
 * Useful for form controls that require string values (like RadioGroup)
 *
 * @param value - The boolean value to convert
 * @param defaultValue - The default string value to return if value is null/undefined (defaults to "true")
 * @returns "true" if value is true, "false" if value is false, or defaultValue if value is null/undefined
 */
export function booleanToString(
  value: boolean | null | undefined,
  defaultValue: string = "true"
): string {
  if (value === true) return "true";
  if (value === false) return "false";
  return defaultValue;
}

/**
 * Converts a string representation back to boolean
 * Useful for handling form control values that come as strings
 *
 * @param value - The string value to convert ("true" or "false")
 * @returns true if value is "true", false otherwise
 */
export function stringToBoolean(value: string): boolean {
  return value === "true";
}
